<template>
    <div class="userContainer">
        <el-row>
            <el-col>
                <el-button size="small" type="primary" @click="addUser('add')" style="margin-bottom: 10px">添加</el-button>
            </el-col>
        </el-row>
        <el-row v-has="'user:select'">
            <el-col>
                <transition name="el-zoom-in-center">
                    <el-table
                            :data="tableData"
                            v-show="show"
                            style="width: 100%"
                            stripe
                            border
                            highlight-current-row
                            element-loading-text="正在加载数据">
                        <el-table-column
                                label="id"
                                align="center"
                                width="50">
                            <template slot-scope="scope">
                                <el-tooltip class="item" effect="dark" content="用户ID" placement="right">
                                    <span>{{ scope.row.id }}</span>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="用户名"
                                prop="username"
                                align="center">
                        </el-table-column>
                        <el-table-column
                                label="头像"
                                align="center">
                            <template slot-scope="scope">
                                <img :src="scope.row.avatar" class='avatar' alt="">
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="昵称"
                                width="150"
                                prop="nickName"
                                align="center">
                        </el-table-column>
                        <el-table-column
                                label="手机号"
                                prop="mobile"
                                align="center">
                        </el-table-column>
                        <el-table-column
                                label="角色"
                                prop="role.roleDesc"
                                align="center">
                        </el-table-column>
                        <el-table-column
                                label="注册时间"
                                prop="createTime"
                                align="center"
                                width="200px">
                        </el-table-column>
                        <el-table-column label="状态"  align="center">
                            <template slot-scope="scope">
                                <el-switch
                                        v-model="scope.row.status"
                                        :active-value="0"
                                        :inactive-value="1"
                                        disabled
                                        @change="changeSwitch(scope.row)">
                                </el-switch>
                            </template>
                        </el-table-column>
                        <el-table-column
                                label="操作"
                                align="center"
                                width="200px">
                            <template slot-scope="scope">
                                <el-button
                                        size="mini"
                                        type="primary"
                                        icon="el-icon-edit"
                                        plain
                                        @click="handleEdite(scope.$index, scope.row)">修改</el-button>
                                <el-button
                                        size="mini"
                                        type="danger"
                                        icon="el-icon-delete"
                                        plain
                                        @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </transition>
                <el-row>
                    <el-col :span="24">
                        <el-pagination
                                class="pagination"
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page.sync="paginations.page_index"
                                :page-sizes="paginations.page_sizes"
                                :page-size="paginations.page_size"
                                :layout="paginations.layout"
                                :total="paginations.total">
                        </el-pagination>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
        <!-- 弹框页面 -->
        <add-edite-user :dialog='dialog' :formData="formData" @result='reserve'></add-edite-user>
    </div>
</template>

<script>
    import { getUserAll,delUser } from "@/api/index";
    import AddEditeUser from "../../components/user/AddEditeUser.vue"

    export default {
        components:{
            AddEditeUser
        },
        data() {
            return {
                paginations:{
                    page_index: 1,//当前位于哪页
                    total: 0,//总数
                    page_size: 5,//每页显示多少条
                    page_sizes: [5 ,10 ,20],//下拉选择
                    layout: 'total, sizes, prev, pager, next, jumper'
                },
                formData:{},
                dialog: {
                    show: false,//dialog的显示
                    title: "添加",
                    clickModal: false,
                    pressEscape: true
                },
                tableData:[],
                show: false,//初始隐藏  为了打开的动画效果
                selectRow: {}
            }
        },
        methods: {
            addUser(val){
                this.dialog.title = '添加'
                this.formData = {
                    id: null,
                    username: '',
                    password: '',
                    avatar: 'https://s1.ax1x.com/2018/05/19/CcdVQP.png',
                    nickName: '',
                    mobile: '',
                    email: '',
                    roleId: '',
                    status: 0,
                    type: 'add'
                }
                this.dialog.show = true;
            },
            handleEdite(index, row){
                this.dialog.title = '修改'
                this.formData = row
                this.formData.type = 'update'
                this.dialog.show = true
            },
            handleDelete(index, row){
                if(row.roleId === 1 || row.roleName === 'admin'){
                    this.$message({
                        showClose: true,
                        message: "超级管理员角色无法删除",
                        type: 'error'
                    })
                    return
                }
                this.$confirm("该操作会让用户数据永久删除,您确定要删除用户吗?", '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delUser(row.id).then(res => {
                        if (res.success == true) {
                            this.$message({
                                showClose: true,
                                message: '删除成功',
                                type: 'success'
                            })
                            this.getUserAll()
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: 'error'
                            })
                        }
                    });
                }).catch(() => {

                });
            },
            getUserAll(){
                let that = this
                getUserAll({
                    pageIndex: this.paginations.page_index,
                    size: this.paginations.page_size
                }).then(res => {
                    if (res.success == true) {
                        that.tableData = res.result.list
                        this.paginations.total = res.result.total
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'error'
                        })
                    }
                });
            },
            reserve: function(val){
                this.dialog.show = false
                let str = '修改成功'
                if(val === 'add'){
                    str = '添加成功'
                }
                this.$message({
                    showClose: true,
                    message: str,
                    type: 'success'
                })
                this.getUserAll()
            },
            handleSizeChange(val) {
                this.paginations.page_size = val
                this.getUserAll()
            },
            handleCurrentChange(val) {
                this.paginations.page_index = val
                this.getUserAll()
            }
        },
        created(){
            this.getUserAll()
        },
        mounted() {
            this.show = true
        }
    }
</script>
<style lang="scss">
    .userContainer{
        background-color: #FFFFFF;
        padding: 16px;
        margin: 20px;
        border-radius: 10px;
        -webkit-box-shadow:0px 3px 3px #c8c8c8;
        -moz-box-shadow:0px 3px 3px #c8c8c8;
        box-shadow:0px 3px 3px #c8c8c8;

        .el-table--enable-row-hover .el-table__body tr:hover>td{
            background-color: #ECF5FF;
        }

        .middle-menu .el-button+.el-button{
            margin-top: 20px;
            margin-left: 0px;
        }

        img {
            max-width: 50px;
        }
    }
</style>
